(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["axn-market-tools"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__axnMarketToolsInitialized) return;
    window.__axnMarketToolsInitialized = true;

    var tools = document.getElementById('axn-market-tools');
    if (!tools) return;

    var observer;
    var frame;

    function setImportant(element, property, value) {
      if (element) element.style.setProperty(property, value, 'important');
    }

    function optionLabel(option) {
      return (option.textContent || option.label || option.value || '').replace(/\s+/g, ' ').trim();
    }

    function currentLanguageLabel(selector, select) {
      var appLabel = selector && selector.querySelector(':scope > p');
      var appText = appLabel && (appLabel.textContent || '').replace(/\s+/g, ' ').trim();
      if (appText && appText !== 'Select Language') return appText;
      return select && select.options && select.options[select.selectedIndex] ? optionLabel(select.options[select.selectedIndex]) : '';
    }

    function normalizeTranslateLayout(root, selector, control) {
      [root, selector].forEach(function(element) {
        setImportant(element, 'position', 'static');
        setImportant(element, 'inset', 'auto');
        setImportant(element, 'display', 'inline-flex');
        setImportant(element, 'align-items', 'center');
        setImportant(element, 'width', 'auto');
        setImportant(element, 'min-width', '0');
        setImportant(element, 'height', '100%');
        setImportant(element, 'margin', '0');
        setImportant(element, 'padding', '0');
        setImportant(element, 'background', 'transparent');
        setImportant(element, 'box-shadow', 'none');
        setImportant(element, 'transform', 'none');
        setImportant(element, 'overflow', 'visible');
        setImportant(element, 'z-index', 'auto');
      });

      Array.prototype.forEach.call(selector.children, function(child) {
        if (child === control) return;
        setImportant(child, 'pointer-events', 'none');
        setImportant(child, 'position', 'absolute');
        setImportant(child, 'width', '1px');
        setImportant(child, 'height', '1px');
        setImportant(child, 'margin', '-1px');
        setImportant(child, 'padding', '0');
        setImportant(child, 'opacity', '0');
        setImportant(child, 'overflow', 'hidden');
        setImportant(child, 'border', '0');
      });
    }

    function updateTranslateControl(control, select) {
      if (!control || !select) return;
      var triggerLabel = control.querySelector('[data-axn-translate-label]');
      var menu = control.querySelector('.axn-translate-menu');
      var options = select.options ? Array.prototype.slice.call(select.options) : [];
      if (!menu || !triggerLabel) return;

      if (menu.dataset.optionCount !== String(options.length)) {
        menu.innerHTML = '';
        options.forEach(function(option, index) {
          var item = document.createElement('button');
          item.type = 'button';
          item.className = 'axn-translate-option';
          item.dataset.index = String(index);
          item.textContent = optionLabel(option);
          item.setAttribute('role', 'menuitemradio');
          item.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            select.selectedIndex = index;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            control.classList.remove('is-open');
            control.querySelector('.axn-translate-trigger').setAttribute('aria-expanded', 'false');
            updateTranslateControl(control, select);
          });
          menu.appendChild(item);
        });
        menu.dataset.optionCount = String(options.length);
      }

      options.forEach(function(option, index) {
        var item = menu.querySelector('[data-index="' + index + '"]');
        var selected = index === select.selectedIndex;
        if (item) {
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
        }
        if (selected) triggerLabel.textContent = currentLanguageLabel(control.parentElement, select) || optionLabel(option);
      });
    }

    function buildTranslateControl(root) {
      var selector = root && root.matches('.ea-buttonLabel') ? root : root && root.querySelector('.eat-languageSelector');
      var select = selector && selector.querySelector('select');
      if (!selector || !select) return false;

      var control = selector.querySelector('.axn-translate-control');
      if (!control) {
        control = document.createElement('div');
        control.className = 'axn-translate-control';
        control.innerHTML = '<button type="button" class="axn-translate-trigger" aria-haspopup="true" aria-expanded="false"><span data-axn-translate-label></span><svg aria-hidden="true" viewBox="0 0 12 8"><path d="M1 1.5 6 6.5l5-5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button><div class="axn-translate-menu" role="menu"></div>';
        selector.appendChild(control);

        control.querySelector('.axn-translate-trigger').addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          var open = control.classList.toggle('is-open');
          this.setAttribute('aria-expanded', open ? 'true' : 'false');
          updateTranslateControl(control, select);
        });

        select.addEventListener('change', function() {
          updateTranslateControl(control, select);
        });
      }

      normalizeTranslateLayout(root, selector, control);
      updateTranslateControl(control, select);
      return true;
    }

    function mountTranslate() {
      var slot = tools.querySelector('[data-axn-translate-slot]');
      var visibleWidget = document.querySelector('.ea-buttonLabel');
      var root = visibleWidget || document.getElementById('ea-auto-translate-root');
      if (!slot || !root) return;
      if (!slot.contains(root)) slot.appendChild(root);
      if (buildTranslateControl(root)) tools.classList.add('is-translate-ready');
    }

    function mountTools() {
      var desktop = window.matchMedia('(min-width: 768px)').matches;
      var target;

      if (desktop) {
        target = document.querySelector('.t4s-announcement-bar');
        if (target) target.classList.add('axn-has-market-tools');
        var announcementSection = document.getElementById('shopify-section-announcement-bar');
        if (announcementSection) announcementSection.classList.add('axn-has-market-tools');
        tools.classList.remove('is-mobile-footer');
        tools.classList.add('is-desktop-toolbar');
      } else {
        document.querySelectorAll('.axn-has-market-tools').forEach(function(element) {
          element.classList.remove('axn-has-market-tools');
        });
        target = document.querySelector('#shopify-section-footer .t4s-section-inner') || document.getElementById('t4s-footer');
        tools.classList.remove('is-desktop-toolbar');
        tools.classList.add('is-mobile-footer');
      }

      if (target && tools.parentElement !== target) target.appendChild(tools);
      tools.classList.toggle('is-mounted', Boolean(target));
      mountTranslate();
    }

    function scheduleMount() {
      if (frame) return;
      frame = window.requestAnimationFrame(function() {
        frame = null;
        mountTools();
      });
    }

    document.addEventListener('click', function(event) {
      var control = tools.querySelector('.axn-translate-control.is-open');
      if (control && !control.contains(event.target)) {
        control.classList.remove('is-open');
        control.querySelector('.axn-translate-trigger').setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      var control = tools.querySelector('.axn-translate-control.is-open');
      if (control) {
        control.classList.remove('is-open');
        control.querySelector('.axn-translate-trigger').setAttribute('aria-expanded', 'false');
      }
    });

    window.addEventListener('resize', scheduleMount, { passive: true });
    document.addEventListener('shopify:section:load', scheduleMount);

    observer = new MutationObserver(scheduleMount);
    observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });

    mountTools();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-floating-button"] && !Shopify.designMode) return;
  try {
    (function() {
  function syncPreviewOffset() {
    document.documentElement.classList.toggle('axnine-theme-preview', Boolean(document.getElementById('PBarNextFrame')));
  }

  function removeOceanPaymentFooterLogos() {
    document.querySelectorAll('footer + div').forEach(function(node) {
      if (node.querySelector('img[src*="mds.oceanpayment.com/assets/shopifylogo/svg/"]')) node.remove();
    });
  }

  removeOceanPaymentFooterLogos();
  syncPreviewOffset();
  document.addEventListener('DOMContentLoaded', removeOceanPaymentFooterLogos);
  document.addEventListener('DOMContentLoaded', syncPreviewOffset);
  window.addEventListener('load', removeOceanPaymentFooterLogos);
  window.addEventListener('load', syncPreviewOffset);
  window.setTimeout(syncPreviewOffset, 1200);
})();
  } catch(e) { console.error(e); }
})();

})();
